import type { RouteFactory } from '@/routing/types'
import { Outlet, redirect } from 'react-router-dom'
import { MedChronAssetRouteSegments, MedChronAssetTabs } from '@/medical-chronology/asset/constants'
import MedChronEventsTable from '@/medical-chronology/events/components/MedChronEventsTable'
import { MedChronEventsTableVariant } from '@/medical-chronology/events/components/med-chron-events-table-variant'
import MedChronAssetRoot from '@/medical-chronology/asset/components/MedChronAssetRoot'
import MedChronAssetLayout from '@/medical-chronology/asset/components/MedChronAssetLayout'
import AddFilesPage from '@/medical-chronology/asset/components/add-files/AddFilesPage'
import SourceFilesTab from '@/medical-chronology/asset/components/source-files/SourceFilesTab'
import MedChronEditGuard from '@/medical-chronology/asset/components/MedChronEditGuard'

/**
 * Creates chronology routes for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/medical-chronology/...
 *
 * The living chronology uses user_file ids for every ingestion path.
 *
 * The index is the matter's chronology (one per matter).
 *
 * @see MatterLayout for parent route context
 */
export const createChronologyChildRoutes: RouteFactory = () => [
  {
    path: 'medical-chronology',
    children: [
      {
        element: (
          <MedChronAssetRoot>
            <Outlet />
          </MedChronAssetRoot>
        ),
        children: [
          // The living chronology (tabbed shell)
          {
            element: <MedChronAssetLayout />,
            children: [
              { index: true, loader: () => redirect(MedChronAssetTabs.ALL_EVENTS) },
              { path: MedChronAssetTabs.ALL_EVENTS, element: <MedChronEventsTable variant={MedChronEventsTableVariant.ALL_EVENTS} /> },
              { path: MedChronAssetTabs.DETAILED_VIEW, element: <MedChronEventsTable variant={MedChronEventsTableVariant.DETAILED_VIEW} /> },
              { path: MedChronAssetTabs.SOURCE_FILES, element: <SourceFilesTab /> },
            ],
          },
          // Stage files only after current membership and the Editor flag allow editing.
          {
            element: <MedChronEditGuard />,
            children: [{ path: MedChronAssetRouteSegments.ADD_FILES, element: <AddFilesPage /> }],
          },
          // Saved report URLs and other unknown paths land on the chronology.
          { path: '*', loader: () => redirect('..') },
        ],
      },
    ],
  },
]
